import { AccountsApiService } from '@accounts/domain';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class RetrieveCredentialsApiService extends AccountsApiService {
  requestRetrieveCredentials(retrieveCredentialParams: { email: string }): Observable<number> {
    return this._post(
      '/v1/credential-net/credentials/email_credentials',
      retrieveCredentialParams,
    ).pipe(
      map((res) => this._handleResponse(res)),
      catchError((res) => this._handleError(res)),
    );
  }
}
